import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BannerCardService } from './banner-card.service';

@Component({
  selector: 'app-banner-card',
  templateUrl: './banner-card.component.html',
  styleUrls: ['./banner-card.component.scss'],
  animations: [
    trigger('expand', [
      transition('void <=> *', []),
      transition('* <=> *', [
        style({height: '{{startHeight}}px'}),
        animate('0.75s ease'),
      ], {params: {startHeight: 0, startWidth: 0}})
    ])
  ]
})
export class BannerCardComponent implements OnInit, OnDestroy {
  @Output() outputClick = new EventEmitter<boolean>();

  @Input() bannerTitle!: string;
  @Input() bannerText!: string;
  @Input() clickText?: string = 'Learn More';

  expandBanner = false;
  bannerCardSubscription;

  constructor(public bannerCardService: BannerCardService) {
    this.bannerCardSubscription = this.bannerCardService.bannerCardSub.subscribe((e) => {
      this.expandBanner = e;
    });
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    if (this.bannerCardSubscription) {
      this.bannerCardSubscription.unsubscribe();
    }
  }


  clickBanner() {
    this.expandBanner = true;
    this.bannerCardService.clickBanner(this.expandBanner);
  }

  signup(url) {
    window.open(url, "_blank");
    this.bannerCardService.clickBanner(false);
  }

  back() {
    this.bannerCardService.clickBanner(false);
  }

}
